export default {
  club_name: 'Skiljebo SK',
  club_name_short: 'skiljebosk',
  stadium_name: '',
  staging_url: 'https://skiljebosk.api.fangroup.io',
  prod_url: 'https://skiljebosk.api.fangroup.io',
  api: '/api',
  facebook: '',
  basename: '/skiljebosk',
  club_logo: '/assets/teams/skiljebosk.png',
  app_name: 'skiljebosk',
  websale_name: 'skiljebosk',
  ntb_team_id: 10071,
  microservice_url: 'https://stats.api.fangroup.io',
  currencyCaps: 'SEK',
  currencyShort: 'Kr',
  currencyShortSmall: 'kr',
  clubSportalityAvailable: false,
  leagueSportalityAvailable: false,
  cloudIdName: 'skiljebosk',
  monolithEnabled: false,
  clubWebsiteEnabled: true,
};
